export class PaginatedListPage {
  number: number
  current: boolean

  constructor(number: number, current: boolean) {
    this.number = number
    this.current = current
  }
}
